// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"be31cac3","434":"def33d43","527":"b9544809","681":"11d7ff5d","703":"88a14147"}[chunkId] + ".chunk.js";
};